import React from "react";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import SettingsIcon from "@material-ui/icons/Settings";
import { withStyles } from "@material-ui/core/styles";

import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";

import OfflineAvailableButton from "../components/OfflineAvailableButton";

const styles = (theme) => ({
    buttonStyle: {
        padding: "5px 10px 0 10px",
    },
});

class SettingsMenu extends React.Component {
    state = {
        anchorEl: null,
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { anchorEl } = this.state;
        const {
            classes: { buttonStyle },
            history,
            generalTranslations,
            connectionStatus,
        } = this.props;

        const isOnline = connectionStatus === "online";
        const hasServiceWorkerSupport = "serviceWorker" in navigator;
        const isStandalone = "standalone" in window.navigator && window.navigator.standalone;

        return (
            <div>
                <ButtonBase
                    disableRipple
                    disableTouchRipple
                    className={buttonStyle}
                    aria-owns={anchorEl ? "settings-menu" : null}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    <SettingsIcon nativeColor="#303C49" />
                </ButtonBase>
                <Menu
                    id="settings-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    getContentAnchorEl={null}
                >
                    {process.env.REACT_APP_ENABLE_OFFLINE && isOnline && hasServiceWorkerSupport && (
                        <MenuItem>
                            <OfflineAvailableButton
                                onFinish={this.handleClose}
                                label={generalTranslations("make-available-offline")}
                            />
                        </MenuItem>
                    )}

                    {isStandalone && (
                        <MenuItem
                            onClick={() => {
                                window.location.reload();
                                this.handleClose();
                            }}
                        >
                            {generalTranslations("update-pwa")}
                        </MenuItem>
                    )}
                    <MenuItem
                        onClick={() => {
                            localStorage.removeItem("token");
                            history.push("/login");
                            this.handleClose();
                        }}
                    >
                        {generalTranslations("logout")}
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

export default compose(withConnectionStatus, withRouter, withGeneralTranslations, withStyles(styles))(SettingsMenu);



// WEBPACK FOOTER //
// ./src/components/SettingsMenu.js